import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { OWNER } from 'customer-data-objects/property/ExternalOptionTypes';
import * as ExternalOptionsReferenceTypes from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import { isPropertySupportedByExternalOptions } from 'customer-data-objects/property/PropertyIdentifier';
import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
import { isExternalOptionsProperty } from 'reference-resolvers-lite/utils/isExternalOptionsProperty';
import { hasUseIsExternalOptionsProperty } from '../permissions/gates';
// This function is meant to provide a way for us to turn on certain external
// options properites as they are added. Eventually we'll be able to remove it
// once all the options we need to resolve are supported by the External Options
// Service.
export const isExternalOptionsField = (field, filterFamily, getIsUngated) => {
  // some filters use cases do not provide filterFamily, do not use external options
  // in this case as it will fail
  // details https://hubspot.slack.com/archives/C50LV5B97/p1628177516067500
  if (!filterFamily) {
    return false;
  }
  if (MissingField.isMissingField(field)) {
    return false;
  }
  // Some usages of the filter still use the old object type constants as a
  // filter family. reference-resolvers-lite requires objectTypeId. This just
  // normalizes the filter family to be an objectTypeId, if the filter family
  // isn't an object type it does nothing.
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const objectTypeId = ObjectTypesToIds[filterFamily] || filterFamily;

  // don't use external options when referencedObjectType is OWNER
  if (field.get('referencedObjectType') === OWNER) {
    return false;
  }

  // don't use external options when externalOptionsReferenceType is OWNER as FilterOperatorOwnerInput does not work with RRL
  if (field.get('externalOptionsReferenceType') === ExternalOptionsReferenceTypes.OWNER) {
    return false;
  }

  // don't use external options for deal_currency_code as FilterOperatorCurrencyCodeInput is not compatible with RRL
  /**
   * @temporary Once hasUseIsExternalOptionsProperty is ungated, this check (+ corresponding field definition override) will be removed
   * @expiration 2025-06-30
   * @deprecated
   */
  if (field.get('name') === 'deal_currency_code') {
    return false;
  }
  if (hasUseIsExternalOptionsProperty(getIsUngated)) {
    return isExternalOptionsProperty(field, objectTypeId);
  }
  return isPropertySupportedByExternalOptions({
    objectTypeId,
    property: field
  });
};